export default [
  {
    path: '/classcard/welcome',
    name: 'PageWelcome',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/welcome/PageWelcome'
      ),
    meta: {
      modular: 23,
      field: 'publishType',
      modularObj: { 1: 23, 2: 24 },
      infoObj: { 1: '欢迎词——首页', 2: '通知——首页' },
      titleObj: { 1: '欢迎词', 2: '通知' },
      info: '欢迎词、通知——首页'
    }
  },
  {
    path: '/classcard/welcomePpad',
    name: 'PageWelcomePad',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/welcome/PageWelcomePad'
      ),
    meta: {
      modular: 23,
      field: 'publishType',
      modularObj: { 1: 23, 2: 24 },
      title: '显示班牌',
      infoObj: { 1: '欢迎词——显示班牌', 2: '通知——显示班牌' }
    }
  },
  {
    path: '/classcard/welcomeDetail',
    name: 'PageWelcomeDetail',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/welcome/PageWelcomeDetail'
      ),
    meta: {
      modular: 23,
      field: 'publishType',
      modularObj: { 1: 23, 2: 24 },
      infoObj: { 1: '欢迎词——详情', 2: '通知——详情' },
      titleObj: { 1: '欢迎词详情', 2: '通知详情' }
    }
  },
  {
    path: '/classcard/welcomeList',
    name: 'PageWelcomeList',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/welcome/PageWelcomeList'
      ),
    meta: {
      modular: 23,
      field: 'publishType',
      modularObj: { 1: 23, 2: 24 },
      infoObj: { 1: '欢迎词——记录', 2: '通知——记录' },
      title: '记录'
    }
  },
  {
    path: '/full/classcard/welcomePublish',
    pathType: 'keep',
    name: 'PageWelcomePublish',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/welcome/PageWelcomePublish'
      ),
    meta: {
      modular: 23,
      field: 'publishType',
      modularObj: { 1: 23, 2: 24 },
      infoObj: { 1: '欢迎词——发布', 2: '通知——发布' },
      titleObj: { 1: '发布欢迎词', 2: '发布通知' }
    }
  },
  {
    path: '/gray/classcard/welcomePublish',
    pathType: 'keep',
    name: 'GrayPageWelcomePublish',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/welcome/gray/PageWelcomePublish'
      ),
    meta: {
      modular: 23,
      field: 'publishType',
      modularObj: { 1: 23, 2: 24 },
      infoObj: { 1: '欢迎词——发布', 2: '通知——发布' },
      titleObj: { 1: '发布欢迎词', 2: '发布通知' }
    }
  },
  {
    path: '/classcard/padList',
    name: 'PagePadSelectedList',
    component: () =>
      import(
        /* webpackChunkName: "classcard" */ '../pages/welcome/PagePadSelectedList'
      ),
    meta: {
      modular: 23,
      field: 'publishType',
      modularObj: { 1: 23, 2: 24 },
      infoObj: { 1: '欢迎词——显示班牌', 2: '通知——显示班牌' },
      title: '显示班牌'
    }
  }
]
